import { FieldFunctionOptions, StoreObject, TypePolicies } from '@apollo/client';

const mergeLocation = (
  existing: StoreObject | undefined,
  incoming: StoreObject,
  { readField, mergeObjects }: FieldFunctionOptions,
) => {
  if (!existing) {
    return incoming;
  }

  if (readField('address', existing) !== readField('address', incoming)) {
    return incoming;
  }

  return mergeObjects(existing, incoming);
};

const cacheTypePolicies: TypePolicies = {
  MeetingRecordingSummaryOutput: {
    merge: true,
  },
  Location: {
    merge: mergeLocation,
  },
};

export { cacheTypePolicies };
